__webpack_require__.p = "/view/area/";